import { render } from "./PaymentSlipStatement.vue?vue&type=template&id=fda3e76a&scoped=true"
import script from "./PaymentSlipStatement.vue?vue&type=script&lang=ts"
export * from "./PaymentSlipStatement.vue?vue&type=script&lang=ts"

import "./PaymentSlipStatement.vue?vue&type=style&index=0&id=fda3e76a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-fda3e76a"

export default script